'use strict';

/* globals define, config, Memory, ajaxify, socket, utils */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/memoryGame/memory-game', ['translator'], function (translator) {
	var isSettingsInitialized = false;

	var uuid;

	var game = {
		settings: {
			wrapperID: 'memory-game',
			level: 0,
			cards: [],
			onGameStart: function () {
				uuid = utils.generateUUID();

				socket.emit('plugins.memoryGamesAnalytics.startedGame', { gameId: ajaxify.data.game.gameId, uuid: uuid, level: ajaxify.data.game.level });

				return false;
			},
			onGameEnd: function (numMoves) {
				socket.emit('plugins.memoryGamesAnalytics.finishedGame', { gameId: ajaxify.data.game.gameId, uuid: uuid, movesCount: numMoves });

				return false;
			},
			translations: {},
		},
	};

	game.init = function () {
		game.settings.cards = getCards();
		game.settings.level = ajaxify.data.game.level;

		if (isSettingsInitialized) {
			return new Memory(game.settings);
		}

		setTranslations(function (translations) {
			game.settings.translations = translations;

			new Memory(game.settings);
			isSettingsInitialized = true;
		});
	};

	function getCards() {
		var cards = [];

		for (var i = 0; i < ajaxify.data.game.images.length; i++) {
			cards.push({ id: i + 1, img: ajaxify.data.game.images[i].url });
		}

		return cards;
	}


	function setTranslations(callback) {
		var translations = [
			'welcome',
			'rules',
			'selectLevel',
			'level',
			'easy',
			'medium',
			'hard',
			'moves',
			'startOver',
			'congratulations',
			'playAgain',
			'roundsNeeded',
		];

		var translationsObject = {};
		for (var i = 0; i < translations.length; i++) {
			var translationKey = translations[i];
			translationsObject[translationKey] = '[[memory_game:' + translationKey + ']]';
		}

		translator.translate(JSON.stringify(translationsObject), function (translated) {
			callback(JSON.parse(translated));
		});
	}

	return game;
});
